import clsx from 'clsx'
import { FieldRenderProps } from 'react-final-form'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { TextField, Typography } from '@mui/material'

type TextareaProps = FieldRenderProps<any, HTMLElement> & {
    label: string
    maxLength?: number
    disabled?: boolean
    fullWidth?: boolean
    rows?: number
    usePre?: boolean
}

const useStyles = makeStyles((theme: Theme) => ({
    label: {
        '& .MuiFormLabel-root': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: '-webkit-fill-available',
        },
        backgroundColor: 'white',
    },
    disabledField: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: theme.palette.getContrastText('bg-backoffice'),
        },
    },
}))

export const ViewTextareaProps = () => (
    <pre className="prettyprint lang-js" style={{ backgroundColor: '#e6e6e6' }}>
        {`type TextareaProps = {
    label: string
    maxLength?: number
    disabled?: boolean
    fullWidth?: boolean
    rows?: number
}`}
    </pre>
)

const TextareaControl = (props: TextareaProps) => {
    const { t } = useTranslation()
    const classes = useStyles()
    const isError: boolean = props.meta.error && props.meta.touched
    const helperText: string = props.meta.error

    return (
        <>
            <Typography>
                {props.label} {!props.disabled && props.required && <label style={{ color: '#d32f2f' }}>{' *'}</label>}
            </Typography>
            <TextField
                variant="outlined"
                className={clsx(classes.label, { [classes.disabledField]: props.disabled })}
                value={props.input.value}
                placeholder={props.placeholder}
                onBlur={props.input.onBlur}
                onChange={props.input.onChange}
                error={isError}
                helperText={isError ? (helperText === 'Required' ? t('LABEL.TEXT_REQUIRED') : helperText) : ''}
                disabled={props.disabled}
                inputProps={{
                    maxLength: props.maxLength,
                    autoComplete: 'off',
                }}
                size="small"
                fullWidth={props.fullWidth}
                multiline={true}
                rows={props.rows ?? 5}
            />
        </>
    )
}

export default TextareaControl
